module.exports = __webpack_public_path__ + "static/img/HigheredLogoWhite.43cadff3.svg";